import { useEffect, useRef, useState } from "react"
import { FetchFromBackoffice } from "../../../utils/request"
import { RecipeItem } from "../../versions/recipes"

let cachedDefinitions: Array<{article_number: string, tags: Array<{name:string, color_code:string}>}> | null = null
let isFetchingDefinitions = false

export const useRecipeDefinitions = () => {
  const definitionsRef = useRef(cachedDefinitions)
  const [, setIsLoaded] = useState(false)

  const groupByArticleNumber = (recipes: RecipeItem[]) => {
    const result: Array<{
      article_number: string
      tags: Array<{ name: string; color_code: string }>
    }> = []

    recipes.forEach(recipe => {
      const existing = result.find(item => item.article_number === recipe.article_number)
      const formattedTags = recipe.tags.flatMap(tag =>
        tag.name && tag.color_code
          ? [{ name: tag.name, color_code: tag.color_code }]
          : []
      )

      if (existing) {
        const newUniqueTags = formattedTags.filter(
          newTag => !existing.tags.some(et => et.name === newTag.name)
        )
        existing.tags.push(...newUniqueTags)
      } else {
        result.push({
          article_number: recipe.article_number,
          tags: formattedTags,
        })
      }
    })

    return result
  }

  useEffect(() => {
    if (cachedDefinitions) {
      definitionsRef.current = cachedDefinitions
      return
    }

    if (isFetchingDefinitions) {
      return
    }

    isFetchingDefinitions = true
    console.log("Fetching recipe definitions")
    FetchFromBackoffice<RecipeItem[]>(`recipes`)
      .then(r => {
        cachedDefinitions = groupByArticleNumber(r)
        definitionsRef.current = cachedDefinitions
        setIsLoaded(true)
      })
      .catch(e => {
        console.warn("Error when fetching recipe definitions: ", e)
      })
      .finally(() => {
        isFetchingDefinitions = false
      })
  }, [])

  return definitionsRef.current
}
